import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface ZakresDatWynik {
  dataOd: string;
  dataDo: string;
}

@Component({
  selector: 'app-zakres-dat',
  templateUrl: './zakres-dat.component.html',
  styleUrls: ['./zakres-dat.component.css'],
})
export class ZakresDatComponent implements OnInit {
  @Input() dataOd: string;
  @Input() dataDo: string;
  @Output() zakresZmieniony = new EventEmitter<ZakresDatWynik>();

  tryb: 'daty' | 'miesiac' = 'daty';
  wybranyRok: number;
  wybranyMiesiac: number;

  lata: number[] = [];
  miesiace = [
    { id: 0, nazwa: 'Styczeń' },
    { id: 1, nazwa: 'Luty' },
    { id: 2, nazwa: 'Marzec' },
    { id: 3, nazwa: 'Kwiecień' },
    { id: 4, nazwa: 'Maj' },
    { id: 5, nazwa: 'Czerwiec' },
    { id: 6, nazwa: 'Lipiec' },
    { id: 7, nazwa: 'Sierpień' },
    { id: 8, nazwa: 'Wrzesień' },
    { id: 9, nazwa: 'Październik' },
    { id: 10, nazwa: 'Listopad' },
    { id: 11, nazwa: 'Grudzień' },
  ];

  ngOnInit(): void {
    const teraz = new Date();
    this.wybranyRok = teraz.getFullYear();
    this.wybranyMiesiac = teraz.getMonth();

    // Generuj listę lat (5 lat wstecz + bieżący)
    for (let i = this.wybranyRok - 5; i <= this.wybranyRok + 1; i++) {
      this.lata.push(i);
    }
  }

  przelaczTryb(): void {
    this.tryb = this.tryb === 'daty' ? 'miesiac' : 'daty';
  }

  zmienMiesiac(kierunek: number): void {
    this.wybranyMiesiac += kierunek;

    if (this.wybranyMiesiac < 0) {
      this.wybranyMiesiac = 11;
      this.wybranyRok--;
    } else if (this.wybranyMiesiac > 11) {
      this.wybranyMiesiac = 0;
      this.wybranyRok++;
    }

    this.ustawZakresMiesiaca();
  }

  ustawZakresMiesiaca(): void {
    const pierwszyDzien = new Date(this.wybranyRok, this.wybranyMiesiac, 1);
    const ostatniDzien = new Date(this.wybranyRok, this.wybranyMiesiac + 1, 0);

    this.dataOd = this.formatujDate(pierwszyDzien);
    this.dataDo = this.formatujDate(ostatniDzien);
  }

  naZmianaRoku(): void {
    this.ustawZakresMiesiaca();
  }

  naZmianaMiesiaca(): void {
    this.ustawZakresMiesiaca();
  }

  zastosuj(): void {
    this.zakresZmieniony.emit({
      dataOd: this.dataOd,
      dataDo: this.dataDo,
    });
  }

  private formatujDate(data: Date): string {
    const rok = data.getFullYear();
    const miesiac = (data.getMonth() + 1).toString().padStart(2, '0');
    const dzien = data.getDate().toString().padStart(2, '0');
    return `${rok}-${miesiac}-${dzien}`;
  }
}
